export const PAYMENT_TYPE = {
  Card: "Card",
  CVS: "CVS",
  Free: "Free",
  Member: "Member",
  PayPal: "PayPal",
  PayPay: "PayPay",
  Phone: "Phone",
  Stripe: "Stripe",
  Venue: "Venue",
} as const;
